import React from 'react';
import {
	little_mail_icon,
	little_phone_icon,
	little_pin_icon,
} from '../../../utils/images';

function QuoteElementExpertDetails(props) {
	return (
		<div className="rdv-detail-container-open">
			<span className="title-regular">Information de l’expert-comptable</span>
			<div className="rdv-expert-info-details">
				<div className="group-infos">
					<span className="title-semibold">{`${
						props?.expert?.firstName || 'N/A'
					} ${props?.expert?.lastName || 'N/A'}`}</span>
				</div>
				<div className="group-infos">
					<span className="title-semibold">
						<img
							src={little_mail_icon}
							alt="little mail icon"
							className="little-mail"
						/>
						{props?.expert?.user?.email || 'N/A'}
					</span>
					<span className="title-semibold">
						<img
							src={little_phone_icon}
							alt="little phone icon"
							className="little-phone"
						/>
						{props?.expert?.user?.phone || 'N/A'}
					</span>
				</div>
				<div className="group-infos group-flex-row-baseline">
					<img
						src={little_pin_icon}
						alt="little pin icon"
						className="little-pin"
					/>
					<div className="group-flex-row">
						<span className="title-semibold">
							{props?.expert?.cabinet?.address || 'N/A'}
						</span>
						<span className="title-semibold">{`${
							props?.expert?.cabinet?.location?.zipCode || 'N/A'
						} ${props?.expert?.cabinet?.location?.city || 'N/A'}`}</span>
					</div>
				</div>
			</div>
		</div>
	);
}

export default QuoteElementExpertDetails;
